import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconDropdownDown2 } from "../../../../../icons/IconDropdownDown2";
import { UnitedStates2 } from "../../../../../icons/UnitedStates2";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const RegionalLogin = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleOpenAccount = () => {
    const currentParams = location.search;
    navigate(`/regional-onboarding_steppper-americanwhite-mobile${currentParams}`);
  };

  const handleLogin = () => {
    const currentParams = location.search;
    navigate(`/regional-landing-americanwhite-mobile${currentParams}`);
  };

  return (
    <div className="regional-login">
      <div className="regional-login-container">
        {/* Dot Pattern Background */}
        <div className="dot-pattern">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(8)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.1 + (row * 0.05) + (col * 0.03);
                return (
                  <circle
                    key={`${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.secundario}
                    fillOpacity={Math.min(opacity, 0.8)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Header */}
        <div className="regional-login-header">
          <div className="back-button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="country-selector">
            <UnitedStates2 className="flag-icon" />
            <IconDropdownDown2 className="dropdown-icon" />
          </div>
        </div>

        {/* Logo */}
        <div className="regional-login-logo">
          {colors.url_logo ? (
            <img src={colors.url_logo} alt="Logo" className="logo-image" />
          ) : (
            <img src="/img/inicio-de-sesion-de-usuario-1-1.svg" alt="Logo" className="logo-image" />
          )}
        </div>

        {/* Tagline */}
        <div className="regional-login-tagline">BANKING AROUND YOU</div>

        {/* Description */}
        <p className="regional-login-description">
          Bank with confidence knowing your money and information are protected at every step.
        </p>

        {/* Action Buttons */}
        <div className="regional-login-actions">
          <button
            className="btn-open-account"
            style={{ backgroundColor: colors.primario }}
            onClick={handleOpenAccount}
          >
            Open an account
          </button>
          <button
            className="btn-login"
            style={{ color: colors.primario }}
            onClick={handleLogin}
          >
            Log in
          </button>
        </div>

        {/* Bottom Dot Pattern */}
        <div className="dot-pattern-bottom">
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(4)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.3 - (row * 0.05);
                return (
                  <circle
                    key={`bottom-${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.primario}
                    fillOpacity={Math.max(opacity, 0.1)}
                  />
                );
              })
            )}
          </svg>
        </div>
      </div>
    </div>
  );
};
